import { AppLication } from "@/CommonDP/mongeView/mongeApiMlib";
// 应用名称集合 方便调用时代码提示
// key 打开应用将自动关闭 "有值同名的key" 的应用--这里我没有用的
// 图纸应用
const appMapList = {
  fileHeader: {
    id: 'fileHeader',
    cnName: '导航',
    icon0: null,
    icon1: null,
    button: 'header',
    key: 'right',
    type: 'dwg',
    component: () => import('./dwgMax/application/fileHeader')
  },
  set: {
    id: 'set',
    cnName: '设置',
    icon0: null,
    icon1: null,
    button: 'top',
    key: 'right',
    type: 'dwg',
    component: () => import('./dwgMax/application/set')
  },
  reset: {
    id: 'reset',
    cnName: '复位',
    icon0: require("./images/reset.png"),
    icon1: require("./images/reset.png"),
    button: 'right',
    key: 'right',
    type: 'dwg',
    component: null
  },
  measure: {
    id: 'measure',
    cnName: '测量',
    icon0: require('./images/measure.png'),
    icon1: require('./images/measureS.png'),
    button: 'bottom',
    key: 'right',
    type: 'dwg',
    component: () => import('./dwgMax/application/measure')
  },
  pencil: {
    id: 'pencil',
    cnName: '画笔',
    icon0: require('./images/pencil.png'),
    icon1: require('./images/pencilS.png'),
    button: 'bottom',
    key: 'right',
    type: 'dwg',
    component: () => import('./dwgMax/application/pencil')
  },
  space: {
    id: 'space',
    cnName: '空间',
    icon0: require('./images/space.png'),
    icon1: require('./images/spaceS.png'),
    button: 'bottom',
    key: 'right',
    type: 'dwg',
    component: () => import('./dwgMax/application/space')
  },
  layer: {
    id: 'layer',
    cnName: '图层',
    icon0: require('./images/layer.png'),
    icon1: require('./images/layerS.png'),
    button: 'bottom',
    key: 'right',
    type: 'dwg',
    component: () => import('./dwgMax/application/layer')
  },
  notation: {
    id: 'notation',
    cnName: '批注',
    icon0: require('./images/notation.png'),
    icon1: require('./images/notationS.png'),
    button: 'bottom',
    key: 'right',
    type: 'dwg',
    component: () => import('./dwgMax/application/notation')
  }

};
// 模型图纸应用
const appModelMapList = {
  fileHeader: {
    id: 'fileHeader',
    cnName: '导航',
    icon0: null,
    icon1: null,
    button: 'header',
    key: 'right',
    type: 'modelDwg',
    component: () => import('./modelMax/application/fileHeaderMap')
  },
  reset: {
    id: 'reset',
    cnName: '复位',
    icon0: require("./images/reset.png"),
    icon1: require("./images/reset.png"),
    button: 'right',
    key: 'right',
    type: 'modelDwg',
    component: null
  },
  modelDwgList: {
    id: 'modelDwgList',
    cnName: '模型图纸',
    icon0: require("./images/modelImage/changeDwg.png"),
    icon1: require("./images/modelImage/changeDwg.png"),
    button: 'left',
    key: 'right',
    type: 'modelDwg',
    component: () => import('./modelMax/application/modelDwgList')
  },
  mapMeasure: {
    id: 'mapMeasure',
    cnName: '测量',
    icon0: require('./images/measure.png'),
    icon1: require('./images/measureS.png'),
    button: 'bottom',
    key: 'right',
    type: 'modelDwg',
    component: () => import('./dwgMax/application/measure')
  },
  mapPencil: {
    id: 'mapPencil',
    cnName: '画笔',
    icon0: require('./images/pencil.png'),
    icon1: require('./images/pencilS.png'),
    button: 'bottom',
    key: 'right',
    type: 'modelDwg',
    component: () => import('./dwgMax/application/pencil')
  },
  issue: {
    id: 'issue',
    cnName: '批注',
    icon0: require('./images/notation.png'),
    icon1: require('./images/notationS.png'),
    button: 'bottom',
    key: 'right',
    type: 'modelDwg',
    component: () => import('./modelMax/application/mapIssue')
  }
};
// 模型应用
const appModelList = {
  fileHeader: {
    id: 'fileHeader',
    cnName: '导航',
    icon0: null,
    icon1: null,
    button: 'header',
    key: 'right',
    type: 'model',
    component: () => import('./modelMax/application/fileHeaderModel')
  },
  reset: {
    id: 'reset',
    cnName: '复位',
    icon0: require("./images/modelImage/reset.png"),
    icon1: require("./images/modelImage/reset.png"),
    button: 'right',
    key: 'right',
    type: 'model',
    component: null
  },
  modelTree: {
    id: 'modelTree',
    cnName: '模型树',
    icon0: require("./images/modelImage/tree.png"),
    icon1: require("./images/modelImage/trees.png"),
    button: 'right',
    key: 'right',
    type: 'model',
    component: () => import('./modelMax/application/modelTree')
  },
  modelAttr: {
    id: 'modelAttr',
    cnName: '模型属性',
    icon0: require("./images/modelImage/attr.png"),
    icon1: require("./images/modelImage/attrs.png"),
    button: 'right',
    key: 'right',
    type: 'model',
    component: () => import('./modelMax/application/modelAttr')
  },
  minimapH5: {
    id: 'minimapH5',
    cnName: '小地图',
    icon0: require("./images/modelImage/miniMap.png"),
    icon1: require("./images/modelImage/miniMap.png"),
    button: 'left',
    key: 'right',
    type: 'model',
    component: () => import('./modelMax/application/minimap')
  },
  set: {
    id: 'set',
    cnName: '设置',
    icon0: null,
    icon1: null,
    button: 'top',
    key: 'right',
    type: 'dwg',
    component: () => import('./modelMax/application/set')
  },
  roaming: {
    id: 'roaming',
    cnName: '漫游',
    icon0: require("./images/modelImage/roam.png"),
    icon1: require("./images/modelImage/roams.png"),
    button: 'bottom',
    key: 'right',
    type: 'model',
    component: () => import('./modelMax/application/roaming')
  },
  modelmeasureH5: {
    id: 'modelmeasureH5',
    cnName: '测量',
    icon0: require("./images/modelImage/measure.png"),
    icon1: require("./images/modelImage/measures.png"),
    button: 'bottom',
    key: 'right',
    type: 'model',
    component: () => import('./modelMax/application/modelMeasure')
  },
  modelSectionH5: {
    id: 'modelSectionH5',
    cnName: '剖切',
    icon0: require("./images/modelImage/section.png"),
    icon1: require("./images/modelImage/sections.png"),
    button: 'bottom',
    key: 'right',
    type: 'model',
    component: () => import('./modelMax/application/modelSection')
  },
  notation: {
    id: 'notation',
    cnName: '批注',
    icon0: require("./images/modelImage/add.png"),
    icon1: require("./images/modelImage/adds.png"),
    button: 'bottom',
    key: 'right',
    type: 'model',
    component: () => import('./modelMax/application/modelNotation')
  }

};
// 其他预览
const appOtherList = {
  otherHeader: {
    id: 'otherHeader',
    cnName: '导航',
    icon0: null,
    icon1: null,
    button: 'header',
    key: 'right',
    type: 'other',
    component: () => import('./docView/application/fileHeader')
  },
  issue: {
    id: 'issue',
    cnName: '批注',
    icon0: require('./images/add.png'),
    icon1: require('./images/adds.png'),
    button: 'bottom',
    key: 'right',
    type: 'other',
    component: () => import('./docView/application/issue')
  },
  list: {
    id: 'list',
    cnName: '批注',
    icon0: require('./images/list.png'),
    icon1: require('./images/list.png'),
    button: 'bottom',
    key: 'right',
    type: 'other',
    component: () => import('./docView/application/issueList.vue')
  }
};
// 图纸
export function getMapList() {
  return [
    appMapList.fileHeader,
    appMapList.set,
    appMapList.reset,
    appMapList.measure,
    appMapList.pencil,
    appMapList.space,
    appMapList.layer,
    appMapList.notation
  ].map((app) => {
    return new AppLication(app);
  });
}
// 模型图纸
export function getModelMapList() {
  return [
    appModelMapList.fileHeader,
    appModelMapList.reset,
    appModelMapList.modelDwgList,
    appModelMapList.mapMeasure,
    appModelMapList.mapPencil,
    appModelMapList.issue
  ].map((app) => {
    return new AppLication(app);
  });
}
// 模型列表
export function getModelList() {
  return [
    appModelList.fileHeader,
    appModelList.reset,
    appModelList.roaming,
    appModelList.minimapH5,
    appModelList.modelmeasureH5,
    appModelList.modelSectionH5,
    appModelList.notation,
    appModelList.set,
    appModelList.modelTree,
    appModelList.modelAttr
    // appModelList.list,
    // appModelList.detail,
  ].map((app) => {
    return new AppLication(app);
  });
}
// 非引擎文件
export function getOtherList() {
  return [
    appOtherList.otherHeader,
    appOtherList.issue,
    appOtherList.list
  ].map((app) => {
    return new AppLication(app);
  });
}
